// extracted by mini-css-extract-plugin
module.exports = {"root":"SuspenseWrapper_root__39rPS"};